/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';

import UnitsList from './UnitsList';
import SelectedDashboardHeader from './SelectedDashboardHeader';
import SimpleNavigationBar from '../../navigation/SimpleNavigationBar';
import Timezone from '../../Timezone';
import NavigationDateRangeArea from '../../../containers/navigation/NavigationDateRangeArea';
import GlobalFilterModal from '../../../containers/common/GlobalFilterModal';

const StyledSelectedDashboard = styled.div`
  .flex-container {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-wrap: nowrap;
    flex: 1;
  }

  .flex-item {
    display: flex;
    flex-direction: column;
    margin: 10px;
    font-weight: bold;
    font-size: 1.5em;
    text-align: center;
    border-width: 1px;
    border-color: #999;
    border-style: solid;
    position: relative;
    width: 100%;
    flex: 1;
    min-width: 100px;
  }

  .template-spinner {
    margin: auto;
  }

  .template-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    height: 40vh;
    margin-bottom: 10px;
  }

  .template-card-error {
    margin-left: 15px;
  }

  .ant-popover-inner-content {
    background-color: #f7f6f4;
  }
`;

const SelectedDashboard = ({
  dashboards,
  setSelectedDashboard,
  selectedDashboard,
  dashboardsObj,
  onCreate,
  onDelete,
  onUpdate,
  onCopy,
  executionState,
  isDashboardManagePermission,
  isUpdating,
}) => {
  useEffect(() => {
    if (!selectedDashboard) {
      setSelectedDashboard((dashboards[0] || {}).id);
    }
  }, []);

  const hasExecutingUnit = useMemo(
    () => Object.keys(executionState).find((unitId) => executionState[unitId].isExecute),
    [executionState]
  );

  return (
    <StyledSelectedDashboard>
      <Spin spinning={isUpdating} size="large">
        <SimpleNavigationBar>
          <Timezone />
          <GlobalFilterModal />
          <NavigationDateRangeArea />
        </SimpleNavigationBar>
        <SelectedDashboardHeader
          dashboards={dashboards}
          dashboardsObj={dashboardsObj}
          setSelectedDashboard={setSelectedDashboard}
          selectedDashboard={selectedDashboard}
          isDisableExecute={!selectedDashboard || hasExecutingUnit}
          isDashboardManagePermission={isDashboardManagePermission}
          dashboard={selectedDashboard && dashboardsObj[selectedDashboard]}
          onCreate={onCreate}
          onUpdate={onUpdate}
          onCopy={onCopy}
          onDelete={onDelete}
        />
        <UnitsList selectedDashboard={selectedDashboard} dashboardsObj={dashboardsObj} />
      </Spin>
    </StyledSelectedDashboard>
  );
};

export default SelectedDashboard;
